import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { fetchUserDataFromAPI } from '@/api/auth'
import { updateUser } from '@/redux/slices/userSlice'
import { AppDispatch } from '@/redux/store'
import { useDispatch } from 'react-redux'
import { setup2FA } from '@/redux/asyncThunks/user'
import { UserRole } from '@/constants/room'
import ROUTES from '@/routes/routes'

const OtpRequired: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()

  const handleSkip = async () => {
    const user = await fetchUserDataFromAPI()
    dispatch(updateUser(user))
    if (user?.role === UserRole.Student) {
      navigate(ROUTES.STUDENT.DASHBOARD)
    } else {
      navigate(ROUTES.PROFESSOR.ROOMS)
    }
  }

  const handle2FA = async () => {
    const setup2FAAction = await dispatch(setup2FA())
    if (setup2FA.fulfilled.match(setup2FAAction)) {
      navigate(ROUTES.VERIFICATION.QR, {
        state: { qrCode: setup2FAAction.payload.qr_code },
      })
    }
  }

  return (
    <div className='flex h-screen w-screen flex-col md:flex-row'>
      <div className='relative hidden flex-1 md:block'>
        <img
          src='/images/auth-background.svg'
          alt='Auth background'
          className='absolute w-1/2 object-cover md:h-full md:w-5/6'
        />
        <div className='flex h-full items-center justify-center'>
          <img
            src='/images/auth-avatar.svg'
            alt='Auth Avatar'
            className='absolute z-10 object-contain md:h-full md:w-auto'
          />
        </div>
      </div>
      <div className='flex flex-1 flex-col items-center justify-center'>
        <div className='flex justify-center'>
          <img
            src='/images/oge.svg'
            alt='Huble logo'
            className='w-1/2 object-contain md:w-full'
          />
        </div>
        <div className='flex w-3/4 flex-col items-center md:w-full'>
          <Card className='w-full max-w-md border-none shadow-none'>
            <CardHeader className='space-y-1 flex flex-col items-center'>
              <CardTitle className='text-4xl font-bold leading-[50px]'>
                OTP Required
              </CardTitle>
              <CardDescription className='text-base text-black font-normal text-center'>
                To proceed, you need to complete OTP verification. Choose an
                option below.
              </CardDescription>
            </CardHeader>
            <CardContent className='space-y-4'>
              <div className='flex justify-between w-full'>
                <Button
                  onClick={handleSkip}
                  variant='secondary'
                  size='default'
                  className='w-[45%]'
                >
                  Skip
                </Button>
                <Button
                  onClick={handle2FA}
                  className='w-[45%] bg-dark-blue hover:bg-dark-blue-hovered'
                >
                  2FA
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default OtpRequired
